import {
    AppBar,
    Toolbar,
    Typography,
    makeStyles,
    // Button,
    IconButton,
    Drawer,
    Link,
    MenuItem,
} from "@material-ui/core";
import { Button } from "react-bootstrap";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import logoImg from "../assets/logo.png";
import { useSelector, useDispatch } from 'react-redux'
import Cookies from 'js-cookie';
import { authActions } from "../Features/authSlice";

const useStyles = makeStyles(() => ({
    header: {
        backgroundColor: "#bde6f9",
        paddingRight: "79px",
        paddingLeft: "118px",
        "@media (max-width: 900px)": {
            paddingLeft: 0,
        },
    },
    logo: {
        fontFamily: "Work Sans, sans-serif",
        fontWeight: 600,
        color: "#FFFEFE",
        textAlign: "left",
    },
    menuButton: {
        fontFamily: "Open Sans, sans-serif",
        fontWeight: 700,
        size: "18px",
        marginLeft: "38px",
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
    },
    drawerContainer: {
        padding: "20px 30px",
    },
}));

export default function Header() {
    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const logout = () => {
        dispatch(authActions.logout())
        localStorage.removeItem('refreshToken');
        Cookies.remove('accessToken');
    }
    const { header, logo, menuButton, toolbar, drawerContainer } = useStyles();

    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });

    const { mobileView, drawerOpen } = state;

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 900
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };

        setResponsiveness();

        window.addEventListener("resize", () => setResponsiveness());

        return () => {
            window.removeEventListener("resize", () => setResponsiveness());
        };
    }, []);

    const displayDesktop = () => {
        return (
            <Toolbar className={toolbar}>
                {femmecubatorLogo}
                <div>{getMenuButtons()}</div>
            </Toolbar>
        );
    };

    const displayMobile = () => {
        const handleDrawerOpen = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: true }));
        const handleDrawerClose = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: false }));

        return (
            <Toolbar>
                <IconButton
                    {...{
                        edge: "start",
                        color: "inherit",
                        "aria-label": "menu",
                        "aria-haspopup": "true",
                        onClick: handleDrawerOpen,
                    }}
                >
                    <MenuIcon />
                </IconButton>

                <Drawer
                    {...{
                        anchor: "left",
                        open: drawerOpen,
                        onClose: handleDrawerClose,
                    }}
                >
                    <div className={drawerContainer}>{getDrawerChoices()}</div>
                </Drawer>

                <div>{femmecubatorLogo}</div>
            </Toolbar>
        );
    };

    const getDrawerChoices = () => {
        return (
            <>
                <Typography variant="h6" component="h1" className={logo} style={{ cursor: 'pointer' }}>
                    <RouterLink to={'/'} className="text-dark" style={{ textDecoration: 'none', color: '#000' }}>
                        <div className="container d-flex align-items-center">
                            <img src={logoImg} alt="" />
                            FindNow
                        </div>
                    </RouterLink>
                </Typography>
                <Link
                    {...{
                        component: RouterLink,
                        to: "/marketplace",
                        color: "inherit",
                        style: { textDecoration: "none" }
                    }}
                >
                    <MenuItem>Marketplace</MenuItem>
                </Link>
                <Link
                    {...{
                        component: RouterLink,
                        to: "/sell-on-findNow",
                        color: "inherit",
                        style: { textDecoration: "none" }
                    }}
                >
                    <MenuItem>Be a Seller</MenuItem>
                </Link>
                {
                    user ?
                        (<>
                            <Link
                                {...{
                                    component: RouterLink,
                                    to: "/admin/dashboard",
                                    color: "inherit",
                                    style: { textDecoration: "none" }
                                }}
                            >
                                <MenuItem>
                                    <Button>Dashboard</Button>
                                </MenuItem>
                            </Link>
                            <MenuItem>
                                <Button onClick={() => logout()}><i class='bx bx-power-off'></i></Button>
                            </MenuItem>
                        </>) :
                        (
                            <>
                                <Link
                                    {...{
                                        component: RouterLink,
                                        to: "/register",
                                        color: "inherit",
                                        style: { textDecoration: "none" }
                                    }}
                                >
                                    <MenuItem>
                                        <Button>Register</Button>
                                    </MenuItem>
                                </Link>
                                <Link
                                    {...{
                                        component: RouterLink,
                                        to: "/login",
                                        color: "inherit",
                                        style: { textDecoration: "none" }
                                    }}
                                >
                                    <MenuItem>
                                        <Button>Login</Button>
                                    </MenuItem>
                                </Link>
                            </>
                        )
                }
            </>
        )
    };

    const femmecubatorLogo = (
        <Typography variant="h6" component="h1" className={logo} style={{ cursor: 'pointer' }}>
            <RouterLink to={'/'} style={{ textDecoration: 'none', color: '#000' }}>
                <div className="container d-flex align-items-center gap-2">
                    <img src={logoImg} alt="" />
                    FindNow
                </div>
            </RouterLink>
        </Typography>
    );

    const getMenuButtons = () => {
        return (<>
            <div className="d-flex justify-content-center align-items-center">
                <ul className="d-flex justify-content-center align-items-center gap-5 m-0">
                    <li>
                        <RouterLink style={{ color: '#349eff' }} className="fw-bold" to={'/marketplace'}>Marketplace</RouterLink>
                    </li>
                    <li>
                        <RouterLink style={{ color: '#349eff' }} className="fw-bold" to={'/sell-on-findNow'}>Be a Seller</RouterLink>
                    </li>
                </ul>
                {user ?
                    (
                        <>
                            <RouterLink to='/admin/dashboard'>
                                <Button
                                    {...{
                                        className: menuButton,
                                    }}
                                >Dashboard</Button>
                            </RouterLink>
                            <Button
                                {...{
                                    className: menuButton,
                                }}>
                                <i onClick={() => logout()} class='bx bx-power-off'></i>
                            </Button>
                        </>
                    ) : (
                        <>

                            <RouterLink to='/register'>
                                <Button
                                    {...{
                                        className: menuButton,
                                    }}
                                >Register</Button>
                            </RouterLink>
                            <RouterLink to='/login'>
                                <Button
                                    {...{
                                        className: menuButton,
                                    }}
                                >Login</Button>
                            </RouterLink>
                        </>)
                }
            </div>
        </>
        );
    };

    return (
        <header className="mb-5">
            <AppBar className={header}>
                {mobileView ? displayMobile() : displayDesktop()}
            </AppBar>
        </header>
    );
}